import { useRouter } from 'next/router';
import { useState, useContext, forwardRef } from 'react';
import {
  Navigation,
  NavigationSecondary,
} from 'remote-com-shared/components/HeaderNavigation/styles/Navigation';
import HeroContext from 'remote-com-shared/components/Hero/context';
import { TwoStepFormModalButton } from 'remote-com-shared/components/TwoStepForm';
import { useBreakpointRange } from 'remote-com-shared/style/breakpoints';
import styled, { css } from 'styled-components';

import { Wrapper, RemoteLogo } from './styles';
import { BrandContainer, Brand } from './styles/Brand';

import { fromDesktopBreakpoint } from '@/src/domains/shared/breakpoints';

const OPEN_FORM_URL_PARAM = 'schedule_demo_form';

const WrapperPosition = styled.div`
  position: relative;
`;

const HeaderCTA = styled(TwoStepFormModalButton)`
  && {
    padding: 0 18px;
    min-height: 34px;
  }
`;

const CTAMobile = styled.div`
  ${fromDesktopBreakpoint(css`
    display: none;
  `)}
`;

const ResourcesHeader = forwardRef(function ResourcesHeader(props, ref) {
  const { compactDisplayCTA = true, brandHref = '/', brandSuffix } = props;
  const { isIntersecting } = useContext(HeroContext);
  const [isOpen, setIsOpen] = useState(false);
  const { query } = useRouter();
  const openModal = !!query[OPEN_FORM_URL_PARAM];
  useBreakpointRange(
    { to: fromDesktopBreakpoint },
    {
      onLeave: () => setIsOpen(false),
    }
  );
  return (
    <WrapperPosition>
      <Wrapper $isOpen={isOpen} $isFixed={!isIntersecting} ref={ref} {...props}>
        <BrandContainer $isOpen={isOpen} $isFixed={!isIntersecting}>
          <Brand as="a" aria-label="Visit homepage" href={brandHref}>
            <RemoteLogo $isOpen={isOpen} $isFixed={!isIntersecting} />
            {brandSuffix && brandSuffix({ $isOpen: isOpen, $isFixed: !isIntersecting })}
          </Brand>

          <CTAMobile>
            {compactDisplayCTA && <HeaderCTA openModal={openModal}>Talk with us</HeaderCTA>}
          </CTAMobile>
        </BrandContainer>

        <Navigation $isOpen={isOpen} aria-hidden={!isOpen}>
          <NavigationSecondary>
            <TwoStepFormModalButton openModal={openModal}>Talk with us</TwoStepFormModalButton>
          </NavigationSecondary>
        </Navigation>
      </Wrapper>
    </WrapperPosition>
  );
});

export default ResourcesHeader;
